export default "__VITE_ASSET__BeQPCJuv__"